import React from "react";
import Router from "router/router";
import * as Api from "api/api";
import {Form, message} from "antd";
import * as cssInJs from "./css/register-form";
import * as css from "./css/registerForm.module.scss";
import {inject, observer} from "mobx-react";
import {useHistory} from 'react-router-dom';
import * as CookieUtil from 'utils/CookieUtil'
import {observable} from "mobx";


const RegisterForm = ({register: store, user, className}) => {
    const history = useHistory();

    const [form] = Form.useForm()


    const onFinish = async (values) => {
        try {
            debugger
            await Api.register(values);
            message.success("注册成功");
            await user.login();
            toHome();
        } catch (error) {
        } finally {
        }
    }

    const toLogin = () => {
        history.replace({
            pathname: Router.Login.path
        });
    };


    const toHome = () => {
        history.replace({
            pathname: Router.Home.path
        });
    }

    const formInitialValues = {
        username: '',
        password: '',
        password2: ''
    }

    return (
        <cssInJs.RegisterForm className={className}>
            <div className="to-login-floor">
                <div className="text">
                    已有账号？前往
                    <span className="color" onClick={toLogin}>
              登录
            </span>
                </div>
                <img
                    src={require("./img/register-icon.png")}
                    alt=""
                    className="icon"
                    onClick={toLogin}
                />
            </div>
            <cssInJs.BgImg src={require("./img/bg.png")}/>
            <cssInJs.TitleFloor>
                <cssInJs.TitleText src={require("./img/title-text.png")}></cssInJs.TitleText>
                <cssInJs.TitleBgImg src={require("./img/title-bg.png")}/>
            </cssInJs.TitleFloor>

            <Form className={css.antdRegisterForm} initialValues={formInitialValues} onFinish={onFinish} form={form}>
                <Form.Item className={css.formItem}>
                    <cssInJs.InputIcon src={require("./img/username-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item noStyle name="username" rules={[{
                        required: true,
                        message: "请输入用户名"
                    }]}>
                        <input
                            className={css.input}
                            placeholder="用户名/邮箱/手机号"
                        />
                    </Form.Item>
                </Form.Item>
                <Form.Item className={css.formItem}>
                    <cssInJs.InputIcon src={require("./img/password-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item noStyle name="password" rules={[{
                        required: true,
                        message: "请输入密码"
                    }]}>
                        <input
                            className={css.input}
                            type="password"
                            placeholder="密码"
                        />
                    </Form.Item>
                </Form.Item>
                <Form.Item className={css.formItem}>
                    <cssInJs.InputIcon src={require("./img/password-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item noStyle name="password2" rules={[
                        {
                            required: true,
                            message: "请确认密码"
                        },
                        ({getFieldValue}) => ({
                            validator(_, value, callback) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }

                                return Promise.reject(new Error("两次输入密码不一致"));
                            }
                        })
                    ]}>
                        <input
                            className={css.input}
                            type="password"
                            placeholder="确认密码"
                        />
                    </Form.Item>
                </Form.Item>
                <div className={css.btnSubmitWrapper}>
                    <cssInJs.BgImg src={require("./img/login-bg.png")}/>
                    <Form.Item noStyle>
                        <button className={css.btnSubmit} type="submit">
                            注册
                        </button>
                    </Form.Item>
                </div>
            </Form>
        </cssInJs.RegisterForm>
    );

}


export default inject("register", "user")(observer(RegisterForm))
